angular.module('unica_invitation_transfer_event.invitation_transfer_event_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// EVENT TRANSFER INVITATION LIST
		.state('app.hospitality.invitation_transfer_event_list', {
			url: '/invitation-transfer-event-list/:event_id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-transfer-event/templates/list.html',
					controller: 'InvitationTransferEventListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Assegnazioni Transfer',
				parent: function($scope) {
					return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
				}
			}
		})

		// EVENT TRANSFER INVITATION CREATE
		.state('app.hospitality.invitation_transfer_event_assign', {
			url: '/invitation-transfer-event-assign/:event_id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-transfer-event/templates/assign.html',
					controller: 'InvitationTransferEventAssignController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Assegna Transfer',
				parent: function($scope) {
					return 'app.hospitality.invitation_transfer_event_list({event_id:' + $scope.event_id + '})';
				}
			}
		});
/*
		// EVENT TRANSFER INVITATION EDIT
		.state('app.hospitality.invitation_transfer_event_edit', {
			url: '/invitation-transfer-event-edit/:event_id/:id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-transfer-event/templates/edit.html',
					controller: 'InvitationTransferEventEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Assegnazione Transfer',
				parent: function($scope) {
					return 'app.hospitality.invitation_transfer_event_list({event_id:' + $scope.event_id + '})';
				}
			}
		});


*/

});

